export const toMoney = (amount, prefix = "£") => {
  const moneyAmount = (Math.round(amount * 100) / 100).toFixed(2)

  return prefix + moneyAmount
}

export const toData = inputAmount => {
  let outputValue = ""
  let formattedInputAmount

  // If we've taken in 'undefined' just make the filter display it as zero
  if (inputAmount === undefined) {
    inputAmount = "0"
  }

  if (typeof inputAmount === "number") {
    inputAmount = `${inputAmount}`
  }

  if (inputAmount.toLowerCase().indexOf("unlimited") < 0) {
    if (isNaN(parseInt(inputAmount, 10)) && parseInt(inputAmount, 10) < 0) {
      throw new Error("Data amounts cannot be negative")
    }
    // Check whether input amount is a number - if not, attempt conversion
    // If that doesn't work, throw an error
    if (typeof inputAmount !== "number" && inputAmount !== "-") {
      formattedInputAmount = parseFloat(inputAmount)
      if (!isNaN(formattedInputAmount)) {
        inputAmount = formattedInputAmount
      } else {
        throw new Error(inputAmount + " is not a valid number")
      }
    }

    // We're using dash here to be like an n/a value - if "-" is passed in, pass it right back out again
    if (inputAmount !== "-") {
      outputValue =
        parseInt(inputAmount, 10) >= 1000 || parseInt(inputAmount, 10) === 0
          ? parseInt(inputAmount, 10) / 1000 + "GB"
          : inputAmount + "MB"
    } else {
      outputValue = inputAmount
    }
  } else {
    outputValue = inputAmount
  }
  return outputValue
}

export const CapAmount = (amount, cap) => {
  return amount > cap ? cap : amount
}
